'use strict';

var processInclude = require('base/util');

import '~base';

$(document).ready(function () {
    processInclude(require('./product/cloudinarydetail'));
});
